import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Game from "@/pages/Game";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import useSiteConfig from "@/hooks/useSiteConfig";

function AdminGate() {
  const { user, booted } = useAuth();
  if (!booted) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-[#6B6A68]" />
      </div>
    );
  }
  return user ? <Admin /> : <AdminLogin />;
}

function App() {
  useSiteConfig();
  return (
    <div className="App paper-texture">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/play/:difficulty" element={<Game />} />
            <Route path="/admin" element={<AdminGate />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
